import { graphql } from "~/gql";

export const DELETE_WORK = graphql(/* GraphQL */ `
  mutation deleteWork($workId: Float!) {
    deleteWork(workId: $workId) {
      workId
    }
  }
`);
